@if (confirm) {
    <div>
        <mat-card appearance="outlined">
            <mat-card-title>Confirm Ungroup</mat-card-title>
            <mat-card-content
                >Are you sure you want to ungroup these
                {{ asset.children.length }} assets?</mat-card-content
            >
            <mat-card-actions>
                <button mat-stroked-button color="default" (click)="confirm = false">No</button>
                <button mat-stroked-button color="warn" (click)="ungroup()">Yes, Ungroup</button>
            </mat-card-actions>
        </mat-card>
    </div>
} @else {
    <div>
        <button mat-stroked-button color="primary" (click)="editGroup()">Reorder Contents</button>
        <button mat-stroked-button color="warn" (click)="confirm = true">Ungroup</button>
    </div>
}
